export default "/images/abc.avif?9b7c29903f9b5fa1f23453f9a871bfcb";